export abstract class ServerSentEventsClient {
  public abstract connect(url: string, options?: EventSourceOptions): void;
  public abstract close(): void;
  public abstract onMessage(callback: (data: any) => void): void;
  public abstract onClose(callback: () => void): void;
  public abstract onError(callback: (err: any) => void): void;
}

export interface EventSourceOptions extends EventSourceInit {
  headers?: { [key: string]: string };
  method?: string;
  payload?: Blob | ArrayBuffer | DataView | FormData | URLSearchParams | string;
}
